import { deepCopy } from "../../../../../../utils/deepCopy"
import { checkIfJson } from "../../../../../../utils/newAttendSurveyUtils"

export const getPriorityListStaticIds = (priorityList) => {
    let staticIds = []
    if (priorityList) {
        let priorityListCopy = JSON.parse(priorityList)
    priorityListCopy.forEach((item) => {
        if (item.answer) {
            staticIds.push(item.id)
        }
    })
    }
    return staticIds

}

export const isDragHandleNeeded = (event) => {
    let droppableId = event.destination && event.destination.droppableId
    if (droppableId) {
        return checkIfJson(droppableId)

    }

}